module.exports = __webpack_public_path__ + "img/vip.7d276977.png";